import { isValidSchema } from "./util";
export class Mosaic {
    constructor(longmin, latmin, longmax, latmax) {
        this.longmin = longmin;
        this.latmin = latmin;
        this.longmax = longmax;
        this.latmax = latmax;
    }
    static create(payload) {
        return new Mosaic(payload.longmin, payload.latmin, payload.longmax, payload.latmax);
    }
    static isValid(payload) {
        if (Object.keys(payload).length === 0 && payload.constructor === Object) {
            return true;
        }
        const schema = ["longmin", "latmin", "longmax", "latmax"];
        return isValidSchema(payload, schema);
    }
}
//# sourceMappingURL=capturesystemmosaic.js.map